import { render } from "./UsefulTrainings.vue?vue&type=template&id=cd70992c"
import script from "./UsefulTrainings.vue?vue&type=script&lang=ts"
export * from "./UsefulTrainings.vue?vue&type=script&lang=ts"
script.render = render

export default script